export const DAY_CELL_W = 100

export const VENDOR_BAR_H = 80

export const HEADER_H = 80

export const MARGIN = 4
